import { useTranslation } from 'react-i18next'

import { Button } from '#/shared/ui/button'
import { DataDropdown } from '#/shared/ui/data-dropdown'
import { SearchInput } from '#/shared/ui/search-input'
import { Toolbar } from '#/shared/ui/toolbar'

interface CampaignToolbarProps {
  search: string
  onSearchChange: (value: string) => void
  rangeFrom: number
  rangeTo: number
  total: number
  onRangeChange: (from: number, to: number) => void
  onNewCampaign?: () => void
}

export function CampaignToolbar({
  search,
  onSearchChange,
  rangeFrom,
  rangeTo,
  total,
  onRangeChange,
  onNewCampaign,
}: CampaignToolbarProps) {
  const { t } = useTranslation()
  return (
    <Toolbar.Bar className="max-sm:flex-col max-sm:items-stretch max-sm:gap-2.5">
      <Toolbar.Left>
        <SearchInput
          size="sm"
          clearable
          className="max-sm:flex-1"
          placeholder={t('campaigns.toolbar.search')}
          value={search}
          onChange={(event) => onSearchChange(event.target.value)}
        />
        {/* No Filters button: `/rows` accepts only the tab, page and size, so
            there is nothing to filter by that the status and ownership tabs
            above do not already cover. Bring it back when the endpoint takes
            filter parameters. */}
      </Toolbar.Left>
      <Toolbar.Right className="max-sm:flex-wrap">
        <DataDropdown
          from={rangeFrom}
          to={rangeTo}
          total={total}
          onPageChange={onRangeChange}
        />
        {/* The design draws an owner dropdown here. Deliberately absent: no
            campaign endpoint takes an owner — `/rows` accepts only the tab and
            `/campaigns` only a `mine` flag — so the ownership axis is exactly
            the Organization and Mine tabs above, which do filter server-side.
            Restore this the day `/rows` accepts a `user_id`. */}
        {/* No chevron: this opens the create modal directly. The Figma draws a
            dropdown caret, but the spine specifies no menu behind it, and a
            caret that opens a dialog reads as a broken menu. */}
        <Button
          variant="warning"
          size="xs"
          pressEffect
          className="px-3.5 font-medium"
          onClick={onNewCampaign}
        >
          {t('campaigns.toolbar.newCampaign')}
        </Button>
      </Toolbar.Right>
    </Toolbar.Bar>
  )
}
